export default __webpack_public_path__ + "static/media/student-positive-test.a0729275.svg";